import React from 'react'
import style from './startsoon.module.css'

function Politybysumit() {
  return (
    <div  className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/b056308344604af884e5b886e998ed72.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
          <p>HINDI   GENERAL AWARENESS</p>
          <h4>Complete Course on World History For NDA I 2022</h4> 
          <p>Starts on Mar 9, 2022 • 12 lessons</p> 
          <p>Sumit Kumar</p>  
        </div>
    </div>        
  )
}
export default Politybysumit;